import React from "react";
import { Oval } from "react-loader-spinner";
import moment from "moment";
import { useSearchParams, useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { DatePicker, BackButton } from "../../../../components";
import {
  getDriverDailyReport,
  setDailyReportOrdersToShow,
} from "../../reportsSlice";
import {
  DailyPaymentsCard,
  DailyDeliveriesCard,
  DailyPickupsCard,
} from "../../components";

import "./DailyReportDriverView.scss";

export const DailyReportDriverView: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const driverId = params.get("driverId");
  const dateString = params.get("date");
  const date = dateString ? new Date(`${dateString}T00:00:00`) : new Date();

  const getDriverDailyReportAPI = useAppSelector(
    (state) => state.reports.getDriverDailyReportAPI
  );
  const dailyDriverReport = useAppSelector(
    (state) => state.reports.dailyDriverReport
  );

  const [selectedDate, setSelectedDate] = React.useState<Date>(date);

  React.useEffect(() => {
    if (!driverId) return;

    const dateString = moment(selectedDate).format("YYYY-MM-DD");
    dispatch(
      getDriverDailyReport({
        date: dateString,
        driverId: driverId,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const onBackButtonClick = () => {
    navigate(-1);
  };

  const onViewOrders = (ids: string[]) => () => {
    dispatch(setDailyReportOrdersToShow(ids));
    navigate("/reports/daily-driver-orders");
  };

  return (
    <div className="daily-report-driver-view-component">
      <BackButton onClick={onBackButtonClick} />

      <div className="title-container">
        <div className="title-row">
          <div className="title-text">Daily Driver Report</div>

          {getDriverDailyReportAPI.loading && (
            <div style={{ marginLeft: 8 }}>
              <Oval
                color="#131313"
                height={20}
                width={20}
                secondaryColor="#0A60BB"
              />
            </div>
          )}
        </div>

        <DatePicker initialDate={selectedDate} onDateChange={setSelectedDate} />
      </div>

      {dailyDriverReport && (
        <>
          <DailyPaymentsCard
            payments={dailyDriverReport.deliveries.payments}
            onViewOrders={onViewOrders}
          />
          <DailyDeliveriesCard
            deliveriesCount={dailyDriverReport.deliveries.counts}
            onViewOrders={onViewOrders}
          />
          <DailyPickupsCard
            pickupsCount={dailyDriverReport.pickups.counts}
            onViewOrders={onViewOrders}
          />
        </>
      )}
    </div>
  );
};
